module.exports = __webpack_public_path__ + "static/media/travel13.73f06cb3.jpg";